import React from "react";
import { motion } from "framer-motion";
import { ArrowDown, Phone } from "lucide-react";
import { SITE } from "../lib/data";

const Hero = () => {
  const scrollNext = () => {
    document.getElementById("chi-siamo")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-pw"
      data-testid="hero-section"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=2000&q=80"
          alt="Proscenio Wedding"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-[var(--pw-bg)]" />
        <div className="absolute inset-0 bg-gradient-to-t from-[var(--pw-bg)] via-transparent to-transparent" />
      </div>

      {/* Decorative top label */}
      <div className="absolute top-28 inset-x-0 z-10 flex justify-center">
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 1 }}
          className="flex items-center gap-4"
        >
          <span className="gold-line" />
          <span className="overline">Music Planner — Dal 2013</span>
          <span className="gold-line" />
        </motion.div>
      </div>

      {/* Main content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif font-light text-[clamp(2.6rem,8vw,6.5rem)] leading-[0.95] tracking-tight text-[var(--pw-text)]"
          data-testid="hero-title"
        >
          Sposarsi
          <br />
          <em className="text-[var(--pw-gold)] font-light">con stile.</em>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 1 }}
          className="mt-8 text-base md:text-lg text-[var(--pw-text)]/75 max-w-2xl mx-auto font-light leading-relaxed"
          data-testid="hero-subtitle"
        >
          Musica live unica, costruita su misura per la tua cerimonia.
          Non la solita colonna sonora — un'esperienza emozionante,
          dal primo accordo all'ultima nota.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7, duration: 0.9 }}
          className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <button
            onClick={() => document.getElementById("contatti")?.scrollIntoView({ behavior: "smooth" })}
            className="btn-pw btn-pw-solid"
            data-testid="hero-cta-preventivo"
          >
            Richiedi Preventivo Gratuito
          </button>
          <a
            href={`tel:${SITE.phone2.replace(/\./g, "")}`}
            className="btn-pw btn-pw-ghost"
            data-testid="hero-cta-phone"
          >
            <Phone size={14} />
            {SITE.phone2}
          </a>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.button
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
        onClick={scrollNext}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-3 text-[var(--pw-text)]/60 hover:text-[var(--pw-gold)] transition-colors"
        data-testid="scroll-down-button"
      >
        <span className="overline text-[10px]">Scopri</span>
        <motion.span
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <ArrowDown size={18} />
        </motion.span>
      </motion.button>
    </section>
  );
};

export default Hero;
